export default __webpack_public_path__ + "static/media/shape-bell.ddf468c8.PNG";